// px 기반 전용 유틸

export function getSafeNumber(value, fallback = 0) {
  const num = Number(value)
  return Number.isFinite(num) ? num : fallback
}

/**
 * 이벤트 좌표를 스크롤 가능한 컨테이너 내부 px 좌표로 변환
 */
export function getStagePoint(event, containerEl) {
  if (!containerEl) {
    return { x: 0, y: 0 }
  }

  const rect = containerEl.getBoundingClientRect()

  const x = event.clientX - rect.left + containerEl.scrollLeft
  const y = event.clientY - rect.top + containerEl.scrollTop

  return {
    x: getSafeNumber(x, 0),
    y: getSafeNumber(y, 0),
  }
}

/**
 * px 범위 제한
 */
export function clampPx(value, min = 0, max = Number.MAX_SAFE_INTEGER) {
  const num = getSafeNumber(value, min)
  if (num < min) return min
  if (num > max) return max
  return num
}